import { Web3Service } from "./eth/Web3Service";
import { Web3AbiService } from "./abi";
import { BasicEthereumService } from "./eth/BasicEthereumService";
import { DEFAULT_ETHEREUM_SERVICE } from "../constants";

export class AppService {
  web3: Web3Service = new Web3Service();

  /**
   * Текущий сервис для взаимодействий с Ethereum
   * EthersService - соединение через ethers (metamask)
   * Web3Service - соединение через web3 и web3modal (metamask, walletconnect)
   */
  currentService: Web3Service = this.web3;

  web3Abi?: Web3AbiService;

  constructor() {}

  setWeb3(web3: Web3Service): AppService {
    this.web3 = web3;
    return this;
  }

  setWeb3Abi(web3Abi: Web3AbiService): AppService {
    this.web3Abi = web3Abi;
    return this;
  }

  setCurrentEthereumService(service: Web3Service) {
    this.currentService = service;
    return service;
  }

  async init() {
    return this.currentService.init();
  }

  async connect() {
    return this.currentService.connect();
  }

  buy(amount: number) {
    return this.currentService.buy(amount);
  }

  mintRef(amount: number, ref: string) {
    return this.currentService.mintRef(amount, ref);
  }

  mintFreeOne() {
    return this.currentService.mintFreeOne();
  }

  get provider() {
    return this.currentService.provider;
  }

  get mintedCount() {
    return this.currentService.mintedCount;
  }
}
